import React, { useContext, useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import Vector from '../components/icons/Vector'
import Stage from '../components/common/Stage'
import Course from '../components/common/Course'
import useApi from '../hooks/useApi'
import {
  getCourse, getMyCourses,
  startCourse,
  updateBadgeCompletion,
} from '../api/supabaseApi'
import { AuthContext } from '../context/AuthContext'
import {getCourseStatus, getProgressCourse, isEarnedCourse} from '../utils/helpers'
import LoadingOverlay from '../components/common/LoadingOverlay'

const CourseDetails = () => {
  const { id } = useParams()
  const navigate = useNavigate()
  const [course, setCourse] = useState(null)
  const [apiLoading, setAPILoading] = useState(false)
  const [isAllBadgesCompleted, setIsAllBadgesCompleted] = useState(false)
  const {
    session: { user, access_token },
  } = useContext(AuthContext)
  const { data, loading } = useApi(
    () => getCourse(id, user.id),
    [id, apiLoading]
  )

  const { data: mainCourses } = useApi(
    () => getMyCourses(user.id, 'main'),
    [user.id]
  )

  useEffect(() => {
    if (mainCourses && mainCourses.length > 0) {
      const allBadgesCompleted = mainCourses.every(course =>
        course.course_badges.every(courseBadge =>
          courseBadge.user_badge_progress.every(progress => progress.completion_percentage === 100)
        ) &&
        course.stages.every(stage =>
          stage.stage_badges.every(stageBadge =>
            stageBadge.user_badge_progress.every(progress => progress.completion_percentage === 100)
          )
        )
      );

      setIsAllBadgesCompleted(allBadgesCompleted)
    }
  }, [mainCourses])

  useEffect(() => {
    if (!loading && data) {
      setCourse(data)
    }
  }, [data, loading])

  const startCourseHandle = async () => {
    setAPILoading(true)
    await startCourse(user.id, course.id, access_token)
    setAPILoading(false)
  }

  const renderStages = () => {
    if (!course?.stages || course.stages.length === 0) {
      return <p className="text-center">Task not found</p>
    }

    return course.stages.map((stage, index) => {
      return (
        <div key={stage.id}>
          <Stage stage={stage} handleBadgeComplete={handleBadgeComplete} />
        </div>
      )
    })
  }

  const handleBadgeComplete = async (stageBadgeIds, completionPercentage, thinkificLink) => {
    setAPILoading(true)
    await updateBadgeCompletion(
      user.id,
      stageBadgeIds,
      completionPercentage,
      id,
      access_token
    )

    if (thinkificLink) {
      window.open(thinkificLink, '_blank');
    }

    setAPILoading(false)
  }

  return (
    <div>
      <div className="bg-white p-6 w-full mx-auto rounded-lg shadow">
        <div className="py-4 cursor-pointer">
          <a onClick={() => navigate(-1)} className="flex justify-start gap-4 ">
            <Vector size="7" color="black" /> Back to Course Library
          </a>
        </div>

        {(loading || apiLoading) && <LoadingOverlay />}

        <Course
          title={course?.title}
          description={course?.description}
          badges={course?.badges}
          haveBg={true}
          progress={getProgressCourse(course)}
          status={getCourseStatus(course)}
          isDetail={true}
          startCourse={startCourseHandle}
          loading={apiLoading}
          isEarned={isEarnedCourse(course)}
          partnerLogo={course?.partner_logo}
        />

        <div className="mt-4">
          <p className="cursor-pointer text-2xl inline-block font-bold py-2 rounded-t-lg text-black">
            Task
          </p>
          <div className="flex flex-col gap-4">
            {renderStages()}
          </div>
        </div>
      </div>
    </div>
  )
}

export default CourseDetails
